import { useTranslation } from 'react-i18next';

import { Box, Text, VStack } from '@bonusly/design-system';
import { useCurrentCompany, useIsBonuslyCompany } from '@bonusly/who-am-i';

import { GithubConnectCard } from '../github/github-connect-card';
import { GranolaConnectCard } from '../granola/granola-connect-card';
import { LinearConnectCard } from '../linear/linear-connect-card';

export const ConnectorsSection = () => {
	const { t } = useTranslation('admin_bizy');
	const company = useCurrentCompany();
	const isBonuslyCompany = useIsBonuslyCompany();

	if (!isBonuslyCompany) return null;

	const hasGranola = company?.bizy_connectors_granola;
	const hasLinear = company?.bizy_connectors_linear;
	const hasGithub = company?.bizy_connectors_github;

	if (!hasGranola && !hasLinear && !hasGithub) return null;

	return (
		<Box>
			<Box pb={3} borderBottom="1px solid" borderColor="border.soft">
				<Text size="md" color="text.softest">
					{t('settingsPanel.sectionIntro.connections')}
				</Text>
			</Box>
			<VStack spacing={0} align="stretch">
				{hasGranola && <GranolaConnectCard />}
				{hasLinear && <LinearConnectCard />}
				{hasGithub && <GithubConnectCard />}
			</VStack>
		</Box>
	);
};
